// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"a088b871","561":"030a44c6","622":"f8063d26","668":"e62c7e79","788":"666a5511","793":"666a5511","839":"d601c395","956":"666a5511"}[chunkId] + ".chunk.css";
};